// extracted by mini-css-extract-plugin
module.exports = {"canvas":"Canvas_canvas__35FB3","inactive":"Canvas_inactive__1qpXH","image":"Canvas_image__2symR","toolBox":"Canvas_toolBox__1MjRy"};